import React, { useState, useEffect } from 'react';

import useData from '../../utilities/useData';
import formatter from '../../utilities/formatter';
import ActionButton from '../shared/buttons/ActionButton';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import PaymentModal from './PaymentModal';

const PaymentDisplay = ({
    customerId,
    disabled,
    parentId,
    recordType,
    showDetail,
    resetParentForm,
    saveParent,
    setParentUrl,
    parentBaseUrl
}) => {

    const baseUrl = recordType === 'job' ? `/api/payments/getjobpayments?jobId=` : `/api/payments/getmiscsalepayments?miscsaleid=`;
    const getUrl = parentId === 0 ? null : `${baseUrl}${parentId}`;

    const [showModal, setShow] = useState(false);
    const { data, fetchData, setData, isLoaded, setUrl } = useData(null, null);

    useEffect(() => {
        setUrl(getUrl);
    }, [parentId]);

    const closeModal = () => {
        setShow(false);
        if (showDetail) fetchData();
        if (resetParentForm) resetParentForm();
    }

    const newItem = {
        amount: 0,
        customerId: customerId,
        franchiseId: window.biztrax.franchiseId,
        date: formatter.dateForInput(new Date()),
        id: 0,
        jobId: recordType === 'job' ? parentId : null,
        miscSaleId: recordType === 'miscSale' ? parentId : null,
        paymentType: null,
        isDeposit: false
    };

    const records = data && data.items &&
        data.items.filter(item => item.id !== 0).map((item, index) =>
        (
            <Row key={index} className="no-gutters small">
                <Col>
                    {formatter.date(item.date)}
                </Col>
                <Col>
                    {item.paymentTypeName}
                </Col>
                <Col>
                    {item.isDeposit && 'deposit'}
                </Col>
                <Col>
                    {formatter.currency(item.amount)}
                </Col>
            </Row>
        ));

    return (
        <div>
            {parentId === 0
                ? (
                    <div className="border-top border-bottom border-light pt-1 pb-1">
                        <Row>
                            <Col>
                            </Col>
                            <Col sm="auto" className="justify-content-center d-flex">
                                <div>
                                    <ActionButton
                                        className="no-hide"
                                        buttonText={'Save and Add Payment'}
                                        imgSource="/images/payment.svg"
                                        onClick={() => saveParent((data) => {
                                            setShow(true);
                                            setParentUrl(`${parentBaseUrl}${data.item.id}`);
                                        })}
                                        disabled={disabled} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                ) : (showDetail ?
                    (

                        <div className="border-top border-bottom border-light pt-1 pb-1">
                            <Row>
                                <Col>
                                    <div className="">
                                        {records}
                                    </div>
                                </Col>
                                <Col sm="auto" className="justify-content-center d-flex">
                                    <div>
                                        <ActionButton
                                            className="no-hide"
                                            buttonText={'Edit Payments'}
                                            imgSource="/images/payment.svg"
                                            onClick={() => {
                                                saveParent(() => setShow(true));
                                            }}
                                            disabled={disabled}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    ) : (
                        <ActionButton
                            imgSource="/images/payment.svg"
                            onClick={() => setShow(true)}
                        />
                    )
                )
            }
            {showModal &&
                <PaymentModal
                data={data}
                setShow={closeModal}
                setData={setData}
                newItem={newItem}
                fetchData={fetchData}
                isLoaded={isLoaded}
                />
            }
        </div>
    )
}

PaymentDisplay.defaultProps = {
    showDetail: false
}


export default PaymentDisplay;